import Main from './Main.vue'
import Leiloeiro from './components/Leiloeiro'
import NovoLeiloeiro from './components/NovoLeiloeiro'

export default [{
  path: 'leiloeiro',
  name: 'leiloeiro',
  component: Main,
  children: [
    {path: '/', component: Leiloeiro, name: 'leiloeiro'},
    {path: 'registrar', component: NovoLeiloeiro, name: 'novo.leiloeiro'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/leiloeiro/routes.js